import { useCallback, useMemo } from "react";
import { EXTERNAL_COMMON, HIDDEN_KEYWORDS, PPV_EVENT, STARBALLON_AUTO_CHARGE, SOOPI_SUBSCRIPTION } from "constant/encrypt";
import useDivertHiddenFunc from "./useDivertHiddenFunc";

export const useCheckHiddenFunc = () => {
    const { starballoonAutoCharging, ppvEvent, externalCommon, soopiSubscription } = useDivertHiddenFunc();

    const regAtagHiddenKeyword = useCallback((RegTarget) => {
        // a 링크 하위에 히든 키워드 포함 되었는지 정규식 체크
        // reduce 로 하나의 히든 키워드만 리턴
        let redirectUrl = "";
        let hiddenFlag = false;
        const data = HIDDEN_KEYWORDS.find((data) => {
            //- encrypt func call
            //const regHiddenKeyword = /(<a\s*href=[\"\']*)(AFREECA::AUTOCHG)\(((http[s]*:)*\/\/((\w)+[\.\/?\=])+(\w)*)\)/i;
            const regex = "(" + data.encrypt_value + ")\\(([\\w\\:\\/\\.]*.+)\\)";
            const regHiddenKeyword = new RegExp(regex, "img");

            const matches = regHiddenKeyword.exec(RegTarget);

            // non match hidden flag
            if (!matches) return false;

            // match hidden flag
            hiddenFlag = true;

            return (redirectUrl = matches[2]);
        });

        return {
            ...data,
            hiddenFlag: hiddenFlag,
            redirectUrl: redirectUrl,
        };
    }, []);

    // 히든 키워드 매칭해서 분기가 필요한 함수 call
    const hiddenKeywordCallFunc = useCallback(
        (aCallHiddenData) => {
            if (aCallHiddenData === null) {
                return;
            }

            const { decrypt_value, redirectUrl = "" } = aCallHiddenData;

            switch (decrypt_value) {
                case STARBALLON_AUTO_CHARGE:
                    starballoonAutoCharging(redirectUrl);
                    break;
                case PPV_EVENT:
                    ppvEvent(redirectUrl);
                    break;
                case EXTERNAL_COMMON:
                    externalCommon(redirectUrl);
                    break;
                case SOOPI_SUBSCRIPTION:
                    soopiSubscription(redirectUrl);
                    break;
                default:
                    break;
            }
        },
        [starballoonAutoCharging, ppvEvent, externalCommon, soopiSubscription],
    );

    return useMemo(
        () => ({
            regAtagHiddenKeyword,
            hiddenKeywordCallFunc,
        }),
        [regAtagHiddenKeyword, hiddenKeywordCallFunc],
    );
};

export default useCheckHiddenFunc;

